export default "__VITE_ASSET__CzWjRxRZ__"